"use strict";

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var ItemVariation = function ItemVariation(_ref) {
  var name = _ref.name,
      price = _ref.price,
      isOnlyVariation = _ref.isOnlyVariation,
      isLastVariation = _ref.isLastVariation;
  var variationStyle = {
    margin: 0
  };
  return /*#__PURE__*/_react["default"].createElement("p", {
    style: variationStyle
  }, "$", price.toFixed(2), " ", !isOnlyVariation && name, !isLastVariation ? /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      margin: '0 0.25rem'
    }
  }, "/") : '');
};

var _default = ItemVariation;
exports["default"] = _default;